<nb-accordion class="mt-3">
  <nb-accordion-item>
    <nb-accordion-item-header class="d-flex align-items-center">
      <div class="flex-grow-1" i18n>Question {{ qi + 1 }}</div>
      <button class="mr-5" nbButton status="danger" size="small" (click)="removeQuestion.emit()">
        <nb-icon icon="trash-2-outline"></nb-icon>
      </button>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div [formGroup]="group">
        <nb-checkbox formControlName="visible" i18n>Visible</nb-checkbox>

        <div class="row mt-3">
          <div class="col">
            <div class="field-label" i18n>Question ID<span style="color: red">*</span></div>
            <input class="w-100" nbInput formControlName="question_id" />
            <div *ngIf="group.get('question_id').hasError('pattern')">
              <div class="error" i18n>ID allows alphanumeric characters, underscore and colon.</div>
            </div>
          </div>
          <div class="col">
            <div class="field-label" i18n>Question Type<span style="color: red">*</span></div>
            <nb-select class="w-100" formControlName="question_type">
              <nb-option *ngFor="let t of questionTypes" [value]="t">{{ t }}</nb-option>
            </nb-select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <div class="field-label" i18n>Question Name</div>
            <input class="w-100" nbInput formControlName="question_name" />
          </div>
          <div class="col">
            <div class="field-label" i18n>Question Title Text</div>
            <input class="w-100" nbInput formControlName="value" />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <div class="field-label" i18n>Question Title ID</div>
            <input class="w-100" nbInput formControlName="title_id" />
          </div>
          <div class="col">
            <div class="field-label" i18n>Question Subtitle ID</div>
            <input class="w-100" nbInput formControlName="subtitle_id" />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <div class="field-label" i18n>Question Image ID</div>
            <input class="w-100" nbInput formControlName="image_id" />
          </div>
          <div class="col">
            <div class="field-label" i18n>Question Display Order</div>
            <input class="w-100" nbInput formControlName="display_order" type="number" />
          </div>
        </div>

        <div class="mt-3" formArrayName="answers">
          <app-survey-answers
            *ngFor="let answer of answers().controls; let ai = index"
            [group]="answer"
            [qi]="qi"
            [ai]="ai"
            (addAction)="addAction.emit({ ai })"
            (removeAnswer)="removeAnswer.emit({ ai })"
            (removeAction)="removeAction.emit({ ai, aci: $event.aci })"
          ></app-survey-answers>
        </div>

        <button class="mt-3" nbButton size="small" status="success" (click)="addAnswer.emit()" i18n>
          <nb-icon icon="plus-square-outline"></nb-icon> New Answer
        </button>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
